import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Aircraft from '../entities/flight/aircraft';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface AircraftState extends ListState<Aircraft> {
  aircraft: Aircraft;
  editAircraft: Aircraft;
}

class AircraftMutations extends ListMutations<Aircraft> {}

class AircraftModule extends ListModule<AircraftState, any, Aircraft> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Aircraft>(),
    loading: false,
    editAircraft: new Aircraft(),
    selectAircraft: new Aircraft(),
  };
  actions = {
    async selectAircraft(
      context: ActionContext<AircraftState, any>,
      payload: any
    ) {
      context.state.editAircraft = payload.data;
    },

    async saveAircraft(
      context: ActionContext<AircraftState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveAirCraft',
        payload.data
      );

      let page = reponse.data.result as PageResult<Aircraft>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateAircraft(
      context: ActionContext<AircraftState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateAirCraft',
        payload.data
      );

      let page = reponse.data.result as PageResult<Aircraft>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAircraft(
      context: ActionContext<AircraftState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetAirCraft',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<Aircraft>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteAircraft(
      context: ActionContext<AircraftState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteAirCraft?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: AircraftState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AircraftState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const aircraftModule = new AircraftModule();
export default aircraftModule;
